module.exports = __webpack_public_path__ + "img/proyecto_1.7c0f7a81.png";